import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { UserManagementTabsEnum } from "../../enums/userManagementTabs";

// TODO: Set to true when Activity History feature is ready
const SHOW_ACTIVITY_HISTORY_TAB = false;

const UserManagementTabs = ({ onTabChange, defaultIndex = UserManagementTabsEnum.USERS }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab iconLeft="person" index={UserManagementTabsEnum.USERS}>
            Users
          </Tabs.Tab>
          <Tabs.Tab iconLeft="lockOpen" index={UserManagementTabsEnum.ROLES}>
            Roles
          </Tabs.Tab>
          {SHOW_ACTIVITY_HISTORY_TAB && (
            <Tabs.Tab iconLeft="lastUpdated" index={UserManagementTabsEnum.ACTIVITY_HISTORY}>
              Activity History
            </Tabs.Tab>
          )}
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default UserManagementTabs;

